import React, { useEffect, useState } from "react";
import { NavLink, useParams, useLocation, useNavigate } from "react-router-dom";
import {Form, message, Select, Button, Input, InputNumber, DatePicker} from 'antd';
import UploadImageFormItem from "./UploadImageFormItem";
import RichText from "./RichText";
import {
  getAllCategoryListApi,
  createArticleApi,
  updateArticleApi,
  getArticleApi,
} from "../../../api/ManageApi";
import GlobalLoader from "../../../components/GlobalLoading";
import viewUtils from "../../../utils/viewUtils";
import dayjs from "dayjs";

const ArticleInfo = () => {
  const [article, setArticle] = useState<any>();
  const [categories, setCategories] = useState<any>();
  const [form] = Form.useForm();
  const location = useLocation();
  const { article_id } = useParams();
  const IsCreate = location.pathname.includes("create");
  const navigate = useNavigate();

  useEffect(() => {
    getAllCategoryListApi().then((res) => {
      if (res.status) {
        setCategories(res?.data?.filter(
          (category: any) => !['about', 'contact'].includes(category?.menu?.page_config?.type)
        ) || [])
      }
    });
  }, []);

  useEffect(() => {
    if(!!article_id) {
      getArticleApi(parseInt(article_id)).then((res) => {
        if (res.status) {
          setArticle(res?.data)
        }
      })
    }
  }, [article_id]);

  useEffect(() => {
    if(!!article) {
      form.resetFields();
      form.setFieldsValue({
        ...article,
        date: !!article?.date ? dayjs(article?.date, "YYYY-MM-DD") : null,
        upload: {
          zh: article?.assets_url?.zh?.map((url: any, index: number) => ({
            uid: `zh-${index}`,
            status: 'done',
            url: url,
          })),
          en: article?.assets_url?.en?.map((url: any, index: number) => ({
            uid: `en-${index}`,
            status: 'done',
            url: url,
          })),
          ja: article?.assets_url?.ja?.map((url: any, index: number) => ({
            uid: `ja-${index}`,
            status: 'done',
            url: url,
          })),
        }
      })
    }
  }, [article, form]);

  const handleSubmit = async () => {
    try {
      await form.validateFields();
    } catch (error: any) {
      try {
        form.scrollToField(error?.errorFields[0].name);
      } catch(error) {}
      return;
    }
    let data = form.getFieldsValue();
    if(!data?.name?.zh && !data?.name?.en && !data?.name?.ja){
      form.scrollToField(['name', 'zh']);
      message.error("请至少填写一个中文或英文或日文名称")
      return null;
    }
    if(
      !data?.upload?.zh?.find((a: any) => a.status === 'done' && !!a.url) &&
      !data?.upload?.en?.find((a: any) => a.status === 'done' && !!a.url) &&
      !data?.upload?.ja?.find((a: any) => a.status === 'done' && !!a.url)
    ) {
      form.scrollToField(['upload', 'zh']);
      message.error("请至少上传一张中文或英文或日文封面")
      return null;
    }
    GlobalLoader.show();
    if(!!data?.id) {
      updateArticleApi({
        id: data?.id,
        sequence: data?.sequence,
        name: data?.name,
        date:  data?.date?.format("YYYY-MM-DD"),
        assets_url: {
          zh: data?.upload?.zh?.filter((a: any) => a.status === 'done' && !!a.url)?.map((a: any) => a.url),
          en: data?.upload?.en?.filter((a: any) => a.status === 'done' && !!a.url)?.map((a: any) => a.url),
          ja: data?.upload?.ja?.filter((a: any) => a.status === 'done' && !!a.url)?.map((a: any) => a.url),
        },
        content: data?.content,
        // eslint-disable-next-line
        links: data?.links?.filter((a: any) => parseInt(a) == a)?.map((a: any) => parseInt(a))
      }).then((res) => {
        if (res.status) {
          message.success('修改内容成功')
          navigate(-1)
        } else {
          message.error(res?.error || '')
        }
        GlobalLoader.hide();
      })
    } else {
      createArticleApi({
        sequence: data?.sequence,
        name: data?.name,
        date:  data?.date?.format("YYYY-MM-DD"),
        assets_url: {
          zh: data?.upload?.zh?.filter((a: any) => a.status === 'done' && !!a.url)?.map((a: any) => a.url),
          en: data?.upload?.en?.filter((a: any) => a.status === 'done' && !!a.url)?.map((a: any) => a.url),
          ja: data?.upload?.ja?.filter((a: any) => a.status === 'done' && !!a.url)?.map((a: any) => a.url),
        },
        category_id: data?.category_id,
        content: data?.content,
        // eslint-disable-next-line
        links: data?.links?.filter((a: any) => parseInt(a) == a)?.map((a: any) => parseInt(a))
      }).then((res) => {
        if (res.status) {
          message.success('创建内容成功')
          if(!!res?.data?.id) {
            navigate(`/system_manage/article/info/${res?.data?.id}`, { replace: true });
          } else {
            navigate(-1)
          }
        } else {
          message.error(res?.error || '')
        }
        GlobalLoader.hide();
      })
    }
  };

  return <>
    <div style={{display: "flex", justifyContent: 'space-between', marginBottom: '1em'}}>
      <NavLink to={`/system_manage/article`}>
        <Button>返回</Button>
      </NavLink>
    </div>
    <Form
      form={form}
      style={{margin: '3em 0'}}
      labelCol={{ span: 5 }}
      wrapperCol={{ span: 18}}>
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
      <Form.Item name="asset_url" hidden>
        <Input />
      </Form.Item>
      <Form.Item
        label={'所属类型'}
        name="category_id"
        rules={[{required: true, message: ''}]}>
        <Select disabled={!IsCreate} options={
          (categories || []).map((category: any) => ({
            label: viewUtils.showCategoryName(category),
            value: category.id
          }))
        } />
      </Form.Item>
      <Form.Item
        name={['name', 'zh']}
        label={'中文名称'}>
        <Input />
      </Form.Item>
      <Form.Item
        name={['name', 'en']}
        label={'英文名称'}>
        <Input />
      </Form.Item>
      <Form.Item
        name={['name', 'ja']}
        label={'日文名称'}>
        <Input />
      </Form.Item>
      <Form.Item
        label={'排序权重'}
        name="sequence">
        <InputNumber min={0} step={1} style={{width: "100%"}} />
      </Form.Item>
      <Form.Item
        label={'文章日期'}
        name="date"
        rules={[{required: true, message: ''}]}>
          <DatePicker style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {() => {
          const menuConfig = categories?.find((c: any) => c.id === form.getFieldValue('category_id'))?.menu;
          if(!menuConfig?.page_config?.can_link) { return null; }
          return (
            <Form.Item
              name={"links"}
              label={'关联内容'}>
              <Select mode="tags" style={{ width: '100%' }} placeholder="请输入有效关联内容ID, 回车分割" />
            </Form.Item>
          )
        }}
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {() => {
          const menuConfig = categories?.find((c: any) => c.id === form.getFieldValue('category_id'))?.menu;
          if(!menuConfig) { return null; }
          return (
            <>
              <UploadImageFormItem
                name={"zh"}
                label={"封面（中文）"}
                text={"上传中文封面"}
                form={form}
                maxCount={menuConfig?.page_config?.asset_max_count || 1}
              />
              <UploadImageFormItem
                name={"en"}
                label={"封面（英文）"}
                text={"上传英文封面"}
                form={form}
                maxCount={menuConfig?.page_config?.asset_max_count || 1}
              />
              <UploadImageFormItem
                name={"ja"}
                label={"封面（日文）"}
                text={"上传日文封面"}
                form={form}
                maxCount={menuConfig?.page_config?.asset_max_count || 1}
              />
            </>
          )
        }}
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {() => {
          const menuConfig = categories?.find((c: any) => c.id === form.getFieldValue('category_id'))?.menu;
          if(!menuConfig) { return null; }
          if(menuConfig?.page_config?.type === 'rent') {
            return ['zh', 'en', 'ja'].map((lang) => (
              <Form.Item key={lang} label={`${lang === 'ja' ? '日' : lang === 'en' ? '英' : '中'}文内容`}>
                <Form.Item
                  name={['content', lang, 'rent']}
                  label={'租金'}>
                  <Input />
                </Form.Item>
                <Form.Item
                  name={['content', lang, 'characteristic']}
                  label={'特征'}>
                  {/* @ts-ignore */}
                  <RichText />
                </Form.Item>
                <Form.Item
                  name={['content', lang, 'accessories']}
                  label={'配件'}>
                  {/* @ts-ignore */}
                  <RichText />
                </Form.Item>
                <Form.Item
                  name={['content', lang, 'specification']}
                  label={'规格'}>
                  {/* @ts-ignore */}
                  <RichText />
                </Form.Item>
              </Form.Item>
            ))
          } else {
            return ['zh', 'en', 'ja'].map((lang) => (
              <Form.Item key={lang} label={`${lang === 'ja' ? '日' : lang === 'en' ? '英' : '中'}文内容`}>
                <Form.Item
                  name={['content', lang, 'content']}>
                  {/* @ts-ignore */}
                  <RichText />
                </Form.Item>
              </Form.Item>
            ))
          }
        }}
      </Form.Item>
      <Form.Item
        wrapperCol={{ span: 18, offset: 5}}
        style={{marginTop: '2em'}}
        rules={[{required: true, message: ''}]}>
          <Button type='primary' style={{width: '100%'}} onClick={handleSubmit}>{!IsCreate ? '更新' : '创建'}</Button>
      </Form.Item>
    </Form>
  </>;
};

export default ArticleInfo;